<template>
 <div class="step2 pr" v-show="visible">
   <h1 class="seat-number abs">1</h1>
   <div class="section">
     <h3>资产评估师资格全国统一考试</h3>
     <div class="leave-screen">
       <div class="leave-title">
         <div class="leave-sub-tit"><i class="el-icon-lock"></i>考生暂离锁屏 </div>
         <div class="time-left">
           <span v-html="this.mesTimerMode == 2 ? '计时：' : '剩余：'"></span> {{ this.timeFilter(String(mes)) }}
         </div>
       </div>
       <div class="leave-con">
         <div class="text-danger">{{errMes}}</div>
         <div class="login-input">
           <input type="text" placeholder="请输入准考证号(任意数字)" class="form-control" v-model="zkzID">
           <button class="btn" @click="backExam"> 继续考试 </button>
         </div>
       </div>


     </div>
   </div>
 </div>
</template>

<script>
 export default {
   name: "leaveScreen",
   data(){
     return{
       errMes:'',
       zkzID:null
     }
   },
   props:{
     visible:{
       type:Boolean,
       default:false
     },
     mesTimerMode: {
       type: Number,
       default: 0
     },
     mes:{
       type:Number,
       default:0
     }
   },
   methods:{
     backExam(){
       if(this.zkzID==''||this.zkzID==null){
         this.errMes = '准考证号不能为空'
       }else{
         this.$emit('closeScreen')
       }
     },
     timeFilter(value){
       let numToStr = number => (number > 9 ? number.toString() : '0' + number)
       let hr = parseInt((value / 60 / 60 % 24).toString())
       let min = parseInt((value / 60 % 60).toString())
       let sec = parseInt((value % 60).toString())
       return `${numToStr(hr)}:${numToStr(min)}:${numToStr(sec)}`
     }
   }
 }
</script>

<style lang="scss">
  $imgUrl: '~@/assets/images/step/';
  .step2{
    width: 100%;
    height: 100%;
    background: url($imgUrl + "student-bg.png") no-repeat center bottom #eef3ff;
    background-size: 100% auto;
    .seat-number{
      font-size: 120px;
      color: #fe6e5f;
      right: 20px;
      font-weight: 500;
    }
    .section{
      h3{
        font-size: 30px;
        text-align: center;
        padding: 80px 15px 20px 15px;
        line-height: 1.5;
        font-weight: 700;
      }
      .leave-screen{
        background: #fff;
        box-shadow: 0 0 20px 0 rgba(171,178,219,.5);
        overflow: hidden;
        margin: 0 auto;
        position: relative;
        height: auto;
        border-radius: 5px;
        padding: 50px 30px;
        max-width: 900px;
        text-align: center;
        .leave-title{
          margin-bottom: 35px;
          justify-content: center;
          display: flex;
          .leave-sub-tit{
            font-size: 18px;
            font-weight: 700;
            color: #8c92ac;
            line-height: 28px;
            i{
              font-size:20px;
              line-height:20px;
              position: relative;
              top:2px;
            }
          }
          .time-left{
            font-size: 14px;
            height: 28px;
            background-color: #8c92ac;
            margin-left: 20px;
            border-radius: 4px;
            padding: 2px 10px;
            color: #fff;
            line-height: 28px;
          }
        }
        .leave-con{
          margin: 16px 0 48px 0;
          .text-danger{
            color: #dc3545;
            margin: 0 50px;
            text-align: left;
            line-height: 1.5;
          }
          .login-input{
            margin: 0 50px;
            display: flex;
            .form-control {
              display: block;
              width: 100%;
              font-size: 1rem;
              line-height: 1.5;
              color: #495057;
              background-color: #fff;
              background-clip: padding-box;
              border: 1px solid #ced4da;
              border-radius: .25rem;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              padding-left: 16px;
              min-height: 1.8rem;
            }
            .btn {
              width: 120px;
              display: inline-block;
              text-align: center;
              white-space: nowrap;
              vertical-align: middle;
              border: 1px solid #007bff;
              padding: .375rem .75rem;
              font-size: 1rem;
              line-height: 1.5;
              border-radius: .25rem;
              color: #fff;
              background-color: #007bff;
              cursor: pointer;
              margin-left: 8px;
            }
          }
        }
      }
    }
  }
</style>
